<!-- 登录日志 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <!-- <h1 class="titleStyle">登录日志</h1> -->
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
          <el-form-item label="用户名：">
            <el-input v-model="Dform.username" placeholder=''></el-input>
          </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="登录时间：">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="To：">
              <el-date-picker
                  
                  v-model="Dform.terminalTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
          <el-col :span="5">
          </el-col >
          
   
        <el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
      </el-row>
    </div>
    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
          stripe
          :border="true"
         v-loading="loading"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          class="table-Style"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="username"
            label="用户名"
            >
          </el-table-column>
          <el-table-column
            prop="email"
            label="邮箱"
            >
          </el-table-column>
          <el-table-column
          prop="loginIp"
          label='登录IP'
          >
          </el-table-column>
          <el-table-column
            prop="loginTime"
            label="登录时间"
            >
          </el-table-column>
        </el-table>

        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>

  </div>
</template>

<script>
import { logLogin } from '@/assets/api/logapi'
export default {
  components: {

  },
  data() {
      return {
        loading:true,
        Dform: {
          username:'',
          started:'',
          expirationTime:'',
        },
        tableData:[],
        multipleSelection:[],
        pageInfo: {
            page: 1,
            pageSize: 10,
        },
        total: 0
      };
  },
  created() {
    this.logListClick()
  },
  mounted() {

  },
  methods: {
      logListClick(){
        const params = {
                username:this.Dform.username,
                startTime:this.Dform.started,
                endTime:this.Dform.expirationTime,
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize,
                userId:JSON.parse(localStorage.getItem('user')).id,


           }
           logLogin(params).then((res)=> {
             this.tableData = res.data.data.list
             this.total = res.data.data.total
              this.loading = false
            }).catch((err)=> {
                console.log(err);
            })
      },
      entrylogClick(){
        this.pageInfo.page = 1
        this.total = 0
        this.logListClick()
        console.log(this.pageInfo.page,this.total,20202020202);
      },
      handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection,val,'this.multipleSelection');
        },
        handleSizeChange (val) {
            console.log(`${val} items pr page`)
        },
        handleCurrentChange (val) {
          console.log(val,'11111111111111111111111');
          this.pageInfo.page = val
          this.logListClick()
        },
        affirm (item) {
            console.log('确认',item);
        },
  },
};
</script>
<style scoped lang="scss">
  .fuzzy-matching-box {
    width: 100%;
    height:  96%;

    .fuzzy-matching-top {
        height: 100px ;
        background-color: #fff;
        border-radius: 15px;
        display: flex;
        align-content: space-around;  
        align-items: center;
        .titleStyle{
          margin-left: 40px;
          font-size: 20px;
          font-weight: 700;
          width: 45%;
        }
      :deep() {
        .el-input--small .el-input__wrapper{
              margin-right: 50px;
              border-radius: 15px
              ;
            }

        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;          
          font-weight: 700;
          font-size: 16px;
          margin-left: 30px;

        }
        .el-input--small .el-input__inner{
          width:110px
        }
        .el-form-item {
            // width: 109%;
            // margin-left: 130px;
          }
        .el-input {
          // width: 100%;
          height: 35px;
        }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: 90px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
        // background-color: #1BC896;
        border-radius: 15px;
      }
     
    }
    :deep() {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
    }
  }
  .fuzzy-matching-bottom {
    height:85%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 30px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
      .table-Style {
          font-size: 16px;
          // border-radius: 15px;
            }
    
    .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        :deep(.el-button--small) {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {

        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 16px;
          user-select: initial;
          color: black;

        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-weight: 700;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
}
</style>
